import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { ASSETS } from "@/lib/constants";

export default function AboutSection() {
  return (
    <section id="about" className="relative overflow-hidden bg-[#F5F5F0] py-24 text-[#0A1712] lg:py-32"
      data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:px-8">
        <Reveal>
          <div>
            <span className="font-oswald text-xs uppercase tracking-[0.28em] text-[#A9821E]">About Us</span>
            <h2 className="mt-3 font-display text-5xl leading-none tracking-tight sm:text-6xl lg:text-7xl">
              A MODERN INDIAN <span className="text-[#0F291E]">FOOD BRAND</span>
            </h2>
            <p className="mt-6 max-w-lg text-lg leading-relaxed text-[#0A1712]/70">
              Dignity Food Kitchen is a modern Indian food brand focused on creating delicious,
              innovative and smarter snacking options for today's lifestyle. We believe great taste,
              quality ingredients and better nutrition can come together in every bite.
            </p>
            <Link to="/shop" data-testid="about-learn-more"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#0F291E] px-8 py-4 font-oswald text-sm uppercase tracking-[0.15em] text-cream transition-transform hover:scale-105">
              Learn More <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>

        <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative">
          <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-[#D4AF37]/40 to-transparent blur-2xl" />
          <img src={ASSETS.moringaTango} alt="Dignity Food Kitchen premium snack presentation"
            loading="lazy" className="relative w-full rounded-[2rem] object-cover shadow-2xl" />
        </motion.div>
      </div>
    </section>
  );
}
